import logo from './logo.svg';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Main from './pages/Main';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/style.css';
import "./css/responsive.css";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Main />}></Route>
        {/* <Route path="/contact/" element={<Contact />}></Route> */}
        {/* <Route path="*" element={<Erreur />}></Route> */}
      </Routes>
    </HashRouter >
  );
}

export default App;
